import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-225fca08")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['my-button',
            _ctx.disabled ? 'my-button-disabled' : 'my-button-abled',
            _ctx.classType[_ctx.type]],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
})